class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    const closeButtons = this.querySelectorAll('.modal__close-button, .drawer__close');
    if (closeButtons.length > 0) {
      closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    } else {
      const closeButton = this.querySelector('button.modal__close-button, button[type="button"]');
      if (closeButton) {
        closeButton.addEventListener('click', this.close.bind(this));
      }
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details') || this.detailsContainer;
    details.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = (event && event.target && event.target.closest('details')) || this.detailsContainer;

    details.classList.remove('menu-closing');
    details.setAttribute('open', true);

    // Force browser layout reflow to register initial opacity: 0 state before transition
    void details.offsetWidth;

    requestAnimationFrame(() => {
      details.classList.add('menu-opening');
    });

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (this.isClosing) return;
    const details = this.detailsContainer;
    if (!details.hasAttribute('open')) return;

    this.isClosing = true;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    details.classList.remove('menu-opening');
    details.classList.add('menu-closing');

    setTimeout(() => {
      details.removeAttribute('open');
      details.classList.remove('menu-closing');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
      this.isClosing = false;
    }, 280);
  }
}

customElements.define('details-modal', DetailsModal);
